<template>
  <div class="login-page">
    <div class="login-form">
      <div class="form-logo">
        <img src="~assets/logo-login.png" alt="">
      </div>
      <div class="form-input">
        <i class="iconfont icon-dingdan"></i><input type="text" v-model="account" name="" value="" placeholder="用户名">
      </div>
      <div class="form-input">
        <i class="iconfont icon-dingdan"></i><input type="password"  v-model="password" name="" value="" placeholder="密码">
      </div>
      <div class="other-option">
        <div class="left-content">
          <img src="~assets/checked.png" alt="" v-if="checked" @click="checked=false">
          <img src="~assets/unchecked.png" class="unchecked-btn" alt="" v-if="!checked" @click="checked=true">
          <span>记住密码</span>
        </div>
        <div class="right-content">
          <a href="javascript:;">登录</a><a>|</a><a @click="goRegister" href="javascript:;">注册</a>
        </div>
      </div>
      <a href="javascript:;" class="form-btn" @click="login">
        登 录
      </a>
    </div>
  </div>
</template>

<script>
  import {
    axiosSysApi2
  } from '../axios_init'

  export default {
    data () {
      return {
        checked: false,
        account: '',
        password: ''
      }
    },
    methods: {
      login () {
        let vm = this
        axiosSysApi2.post('/login', window.JSON.stringify({account: this.account, password: this.password})).then(function (response) {
          if (response.data.data.loginok === 1) {
            vm.$store.dispatch('setLogin', 1)
            vm.$store.dispatch('setUserId', response.data.data.user_id)
            vm.$store.getters.LoginFor ? vm.$router.push(vm.$store.getters.LoginFor) : vm.$router.go(-1)
          } else {
            vm.$store.dispatch('showNoticeMsg', {
              type: 'warning',
              title: '登录失败',
              message: '账号或密码不正确'
            })
          }
        }).catch(function (e) {
          vm.$store.dispatch('showNoticeMsg', {
            type: 'warning',
            title: '登录失败',
            message: e
          })
        })
      },
      goRegister () {
        this.$router.push('/register')
      }
    }
  }
</script>

<style scoped lang="less">
  @import '../style/base.less';
  .login-page {
    position: fixed;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background:url('~assets/login-bak.png');
    background-repeat: no-repeat;
    background-size: 100%, auto;
    .login-form {
      width: 400px;
    }
  }
</style>



// WEBPACK FOOTER //
// login.vue?2f8dc5ef